import * as types from '../actions/actionTypes';

const initialState = {
    geosuggestLanguageSettings: {
        loading: false,
        success: true,
        language: ''
    }
};

export default (state = initialState, action) => {
    switch (action.type) {

        case types.UPDATE_GEOSUGGEST_SETTINGS:
            return { ...state, geosuggestLanguageSettings : { ...state.geosuggestLanguageSettings, ...action.setting } };
            
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/UtilsReducer.js